module.exports = __webpack_public_path__ + "img/bj_kuang_yi.a8729ea8.png";